import styles from './IframeUtil-hashed.scss';
import q from 'q';

// VARS
var TIMEOUT_BEFORE_IFRAME_REJECT = 10000; // time before the iframe is expected to be loaded (in ms)

var ERRORS = { // Errors which can be used to detect the reason
    loadTimeout: 'loadTimeout',
    expectedSrcPartOnLoad: 'expectedSrcPartOnLoad',
    iframeLoadError: 'iframeLoadError'
};

// HELPERS
function getIframeData(iframeEl, loadTimeout) {
    var iframeData = {};
    iframeData.iframeEl = iframeEl;
    iframeData.iframeDoc = iframeEl.contentDocument || iframeEl.contentWindow.document;
    iframeData.iframeWin = iframeEl.contentWindow || iframeEl;
    iframeData.iframeWrapper = iframeEl.parentNode;
    iframeData.clearIframeArtifacts = clearIframeArtifacts.bind(null, iframeEl, loadTimeout); // should be used for cleaning
    return iframeData;
}

function removeIframe(iframeEl) {
    var iframeWrapper = iframeEl.parentNode;
    document.body.removeChild(iframeWrapper); // remove appended nodes
}

/**
 * @param {Object} iframeEl
 * @param {Number} loadTimeout
 */
function clearIframeArtifacts(iframeEl, loadTimeout) {
    iframeEl.onload = null;
    iframeEl.onerror = null;
    clearTimeout(loadTimeout);
    removeIframe(iframeEl);
}

// METHODS
/**
 * Loads a new iframe.
 * Iframe artifacts are cleaned on reject, on resolve should be manually removed from the Promise usage
 *
 * @param {String} src
 * @param {String} [expectedSrcPartOnLoad]
 * @returns {q.promise}
 * @returns {String} {q.Promise.error} If present- describes why Promise is rejected
 */
function loadIframe(_ref) {
    var src = _ref.src,
        expectedSrcPartOnLoad = _ref.expectedSrcPartOnLoad;

    var deferred = q.defer();

    var iframeEl = document.createElement('iframe');
    var iframeWrapper = document.createElement('div');
    iframeWrapper.classList.add(styles.hiddenIframe);
    iframeWrapper.appendChild(iframeEl);

    // Promise with timeout rejections
    // timeout
    var loadTimeout = setTimeout(function () {
        clearIframeArtifacts(iframeEl, loadTimeout);
        deferred.reject({ error: ERRORS.loadTimeout });
    }, TIMEOUT_BEFORE_IFRAME_REJECT);

    // on iframe changes the state
    iframeEl.onload = function () {
        var iframe = getIframeData(iframeEl, loadTimeout);
        if (!iframe.iframeDoc.querySelector('meta[content="Cloud Foundry"],meta[content="Guidewire"]')) {
            // not redirected to a UAA page so must be an external IDP Page
            clearIframeArtifacts(iframeEl, loadTimeout);
            deferred.reject({
                fullPageRedirectRequired: iframe.iframeDoc.URL
            });
            return;
        }
        if (expectedSrcPartOnLoad) {
            // check if the src meets expectations (e.g. iframe was redirected)
            if (!iframe.iframeWin.location.href.includes(expectedSrcPartOnLoad)) {
                clearIframeArtifacts(iframeEl, loadTimeout);
                deferred.reject({ error: ERRORS.expectedSrcPartOnLoad });
                return;
            }
        }

        deferred.resolve(getIframeData(iframeEl, loadTimeout));
    };
    iframeEl.onerror = function () {
        clearIframeArtifacts(iframeEl, loadTimeout);
        deferred.reject({ error: ERRORS.iframeLoadError });
    };

    // start loading
    iframeEl.src = src;
    document.body.appendChild(iframeWrapper);

    return deferred.promise;
}

// EXPORT
export default {
    loadIframe: loadIframe,
    ERRORS: ERRORS
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-js/utils/IframeUtil/index.js
// module id = 140
// module chunks = 0